import React from 'react';
import { Star, Sparkles, Check } from 'lucide-react';
import { CTAButton } from './CTAButton';
export const Hero: React.FC = () => {
  return <section className="pt-6 pb-6 px-4 max-w-3xl mx-auto" data-id="element-67">
      {/* Headlines */}
      <h1 className="font-rounded font-bold text-[2.25rem] sm:text-5xl md:text-6xl text-violet text-center leading-[1.02] mb-3" data-id="element-68">
        La <span className="text-gold-dark" data-id="element-69">Biblioteca Mágica</span> de
        Coloreables Disney
      </h1>

      <p className="text-base sm:text-lg text-textsoft text-center max-w-2xl mx-auto mb-4 font-semibold leading-snug" data-id="element-70">
        Más de <strong className="text-violet" data-id="element-71">50 libros</strong> y{' '}
        <strong className="text-violet" data-id="element-72">2.500 páginas</strong> listas para
        imprimir, colorear y disfrutar durante horas.
      </p>

      {/* Stars + social proof */}
      <div className="flex flex-col items-center mb-5" data-id="element-73">
        <div className="flex gap-0.5 mb-1" data-id="element-74">
          {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-dark text-gold-dark" data-id="element-75" />)}
        </div>
        <p className="text-sm font-bold text-textsoft" data-id="element-76">
          Más de{' '}
          <span className="text-violet font-extrabold" data-id="element-77">
            5.000 familias felices
          </span>
        </p>
      </div>

      {/* GIANT Product Image */}
      <div className="w-full mb-5 relative" data-id="element-78">
        <img src="https://cdn.magicpatterns.com/uploads/d4RRdDi26Um4PeNDBwU8ao/colecion_completa.png" alt="Colección completa Biblioteca Mágica Disney - Más de 50 libros" className="w-full h-auto drop-shadow-2xl" data-id="element-79" />
        {/* Floating sticker */}
        <div className="absolute -top-2 -right-2 sm:top-4 sm:right-4 bg-yellow text-violet rounded-full w-20 h-20 sm:w-28 sm:h-28 flex flex-col items-center justify-center font-rounded font-bold shadow-xl border-4 border-white rotate-12" data-id="element-80">
          <span className="text-sm sm:text-base leading-none" data-id="element-81">+50</span>
          <span className="text-[10px] sm:text-xs leading-none mt-1" data-id="element-82">
            LIBROS
          </span>
        </div>
      </div>

      {/* Price block */}
      <div className="bg-white rounded-2xl border-[3px] border-dashed border-gold px-5 py-4 mb-5 text-center shadow-card" data-id="element-83">
        <p className="text-xs uppercase tracking-widest text-textsoft font-extrabold mb-1" data-id="element-84">
          Precio especial por tiempo limitado
        </p>
        <div className="flex items-baseline justify-center gap-3" data-id="element-85">
          <span className="text-gray-400 line-through text-xl font-bold" data-id="element-86">
            $39.990
          </span>
          <span className="font-rounded font-bold text-5xl text-violet leading-none" data-id="element-87">
            $9.990
          </span>
        </div>
        <p className="text-xs text-textsoft mt-1.5 font-bold" data-id="element-88">
          Ahorras <strong className="text-brandgreen" data-id="element-89">$20.000</strong> · 50% OFF
        </p>
      </div>

      {/* Benefits list (compact) */}
      <ul className="space-y-2 mb-6 max-w-md mx-auto" data-id="element-90">
        {['Más de 50 libros Disney', 'Más de 2.500 páginas', 'Descarga inmediata', 'Listo para imprimir', 'Acceso de por vida'].map((benefit, idx) => <li key={idx} className="flex items-center gap-2.5 text-violet font-bold text-base" data-id="element-91">
            <div className="bg-brandgreen rounded-full p-0.5 flex-shrink-0" data-id="element-92">
              <Check className="text-white w-3.5 h-3.5" strokeWidth={3.5} data-id="element-93" />
            </div>
            <span data-id="element-94">{benefit}</span>
          </li>)}
      </ul>

      <CTAButton data-id="element-95" />
    </section>;
};